import * as React from 'react';
import { SVGProps } from 'react';

const IconAxisXSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M4 5h1L3.5 2 2 5h1v2a.5.5 0 0 0 0 1v2a.5.5 0 0 0 0 1v2.5a.5.5 0 0 0 1 0V11a.5.5 0 0 0 0-1V8a.5.5 0 0 0 0-1V5Z"
      fill="var(--color-typo-system)"
    />
    <path
      d="M11 13v1l3-1.5-3-1.5v1H9a.5.5 0 0 0-1 0H6a.5.5 0 0 0-1 0H2.5a.5.5 0 0 0 0 1H5a.5.5 0 0 0 1 0h2a.5.5 0 0 0 1 0h2ZM7.631 3l1.34 2.386h.052L10.369 3h1.586L9.928 6.5 12 10h-1.615L9.023 7.61H8.97L7.609 10H6l2.079-3.5L6.039 3H7.63Z"
      fill="var(--color-typo-normal)"
    />
  </svg>
);
export default IconAxisXSizeS;
